import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { date: String, mealTypeId: Number, mealPlanId: Number }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
    this.element.classList.add("border-terracotta", "border-2", "border-dashed", "bg-terracotta/10")
  }

  dragleave(_event) {
    this.element.classList.remove("border-terracotta", "border-2", "border-dashed", "bg-terracotta/10")
  }

  async drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-terracotta", "border-2", "border-dashed", "bg-terracotta/10")

    const data = JSON.parse(event.dataTransfer.getData("application/json"))
    const { mealPlanId, sourceDate, sourceMealTypeId, recipeName } = data
    const targetDate = this.dateValue
    const targetMealTypeId = this.mealTypeIdValue

    if (sourceDate === targetDate && String(sourceMealTypeId) === String(targetMealTypeId)) {
      return
    }

    this.showOptimisticMove(recipeName, sourceDate, sourceMealTypeId)

    if (this.hasMealPlanIdValue && this.mealPlanIdValue) {
      await this.deleteExistingMealPlan(this.mealPlanIdValue)
    }

    await this.moveMealPlan(mealPlanId, targetDate, targetMealTypeId)
  }

  showOptimisticMove(recipeName, sourceDate, sourceMealTypeId) {
    const sourceSlot = document.getElementById(`meal_slot_${sourceDate}_${sourceMealTypeId}`)
    if (sourceSlot) {
      const innerDiv = sourceSlot.querySelector("div[data-controller='drop-zone']")
      if (innerDiv) {
        const sourceBg = this.isToday(sourceDate) ? 'bg-terracotta/10' : 'bg-charcoal'
        innerDiv.className = `min-h-[100px] p-2 group relative ${sourceBg}`
        innerDiv.innerHTML = `
          <div class="flex-1 flex items-center justify-center min-h-[60px] text-cream/20">
            <span class="font-mono text-xs animate-pulse">...</span>
          </div>
        `
      }
    }

    const targetBg = this.isToday(this.dateValue) ? 'bg-terracotta/10' : 'bg-charcoal'
    this.element.className = `min-h-[100px] p-2 group relative ${targetBg}`
    if (recipeName) {
      this.element.innerHTML = `
        <div class="flex-1 group/card relative p-1 -m-1 rounded">
          <div class="font-medium text-sm text-cream/50 truncate animate-pulse">
            ${recipeName}
          </div>
          <div class="flex items-center gap-2 mt-1 font-mono text-[10px] text-cream/20">
            <span>...</span>
          </div>
        </div>
      `
    }
  }

  isToday(dateStr) {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    return dateStr === `${year}-${month}-${day}`
  }

  async deleteExistingMealPlan(id) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content
    await fetch(`/meal_plans/${id}`, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
  }

  async moveMealPlan(id, date, mealTypeId) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content
    const params = new URLSearchParams({
      "meal_plan[date]": date,
      "meal_plan[meal_type_id]": mealTypeId
    })

    const response = await fetch(`/meal_plans/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: params
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    }
  }
}
